/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsuariosIndexRouteImport } from './routes/usuarios.index'
import { Route as TransmissoesIndexRouteImport } from './routes/transmissoes.index'
import { Route as SugestoesCombinacoesIndexRouteImport } from './routes/sugestoes-combinacoes.index'
import { Route as LancamentosIndexRouteImport } from './routes/lancamentos.index'
import { Route as ImportacoesIndexRouteImport } from './routes/importacoes.index'
import { Route as GerenciadorAnexacaoIndexRouteImport } from './routes/gerenciador-anexacao.index'
import { Route as FiliaisIndexRouteImport } from './routes/filiais.index'
import { Route as ExtratosBancariosIndexRouteImport } from './routes/extratos-bancarios.index'
import { Route as ComprovantesIndexRouteImport } from './routes/comprovantes.index'
import { Route as CaixasIndexRouteImport } from './routes/caixas.index'
import { Route as ArquivosIndexRouteImport } from './routes/arquivos.index'
import { Route as TransmissoesFilaRouteImport } from './routes/transmissoes.fila'
import { Route as TransmissoesIdRouteImport } from './routes/transmissoes.$id'
import { Route as LancamentosIdRouteImport } from './routes/lancamentos.$id'
import { Route as ImportacoesExtratosRouteImport } from './routes/importacoes.extratos'
import { Route as ImportacoesIdRouteImport } from './routes/importacoes.$id'
import { Route as ExtratosBancariosIdRouteImport } from './routes/extratos-bancarios.$id'
import { Route as ComprovantesIdRouteImport } from './routes/comprovantes.$id'
import { Route as CaixasIdRouteImport } from './routes/caixas.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsuariosIndexRoute = UsuariosIndexRouteImport.update({
  id: '/usuarios/',
  path: '/usuarios/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransmissoesIndexRoute = TransmissoesIndexRouteImport.update({
  id: '/transmissoes/',
  path: '/transmissoes/',
  getParentRoute: () => rootRouteImport,
} as any)
const SugestoesCombinacoesIndexRoute =
  SugestoesCombinacoesIndexRouteImport.update({
    id: '/sugestoes-combinacoes/',
    path: '/sugestoes-combinacoes/',
    getParentRoute: () => rootRouteImport,
  } as any)
const LancamentosIndexRoute = LancamentosIndexRouteImport.update({
  id: '/lancamentos/',
  path: '/lancamentos/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportacoesIndexRoute = ImportacoesIndexRouteImport.update({
  id: '/importacoes/',
  path: '/importacoes/',
  getParentRoute: () => rootRouteImport,
} as any)
const GerenciadorAnexacaoIndexRoute =
  GerenciadorAnexacaoIndexRouteImport.update({
    id: '/gerenciador-anexacao/',
    path: '/gerenciador-anexacao/',
    getParentRoute: () => rootRouteImport,
  } as any)
const FiliaisIndexRoute = FiliaisIndexRouteImport.update({
  id: '/filiais/',
  path: '/filiais/',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtratosBancariosIndexRoute = ExtratosBancariosIndexRouteImport.update({
  id: '/extratos-bancarios/',
  path: '/extratos-bancarios/',
  getParentRoute: () => rootRouteImport,
} as any)
const ComprovantesIndexRoute = ComprovantesIndexRouteImport.update({
  id: '/comprovantes/',
  path: '/comprovantes/',
  getParentRoute: () => rootRouteImport,
} as any)
const CaixasIndexRoute = CaixasIndexRouteImport.update({
  id: '/caixas/',
  path: '/caixas/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArquivosIndexRoute = ArquivosIndexRouteImport.update({
  id: '/arquivos/',
  path: '/arquivos/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransmissoesFilaRoute = TransmissoesFilaRouteImport.update({
  id: '/transmissoes/fila',
  path: '/transmissoes/fila',
  getParentRoute: () => rootRouteImport,
} as any)
const TransmissoesIdRoute = TransmissoesIdRouteImport.update({
  id: '/transmissoes/$id',
  path: '/transmissoes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const LancamentosIdRoute = LancamentosIdRouteImport.update({
  id: '/lancamentos/$id',
  path: '/lancamentos/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportacoesExtratosRoute = ImportacoesExtratosRouteImport.update({
  id: '/importacoes/extratos',
  path: '/importacoes/extratos',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportacoesIdRoute = ImportacoesIdRouteImport.update({
  id: '/importacoes/$id',
  path: '/importacoes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ExtratosBancariosIdRoute = ExtratosBancariosIdRouteImport.update({
  id: '/extratos-bancarios/$id',
  path: '/extratos-bancarios/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ComprovantesIdRoute = ComprovantesIdRouteImport.update({
  id: '/comprovantes/$id',
  path: '/comprovantes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CaixasIdRoute = CaixasIdRouteImport.update({
  id: '/caixas/$id',
  path: '/caixas/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/caixas/$id': typeof CaixasIdRoute
  '/comprovantes/$id': typeof ComprovantesIdRoute
  '/extratos-bancarios/$id': typeof ExtratosBancariosIdRoute
  '/importacoes/$id': typeof ImportacoesIdRoute
  '/importacoes/extratos': typeof ImportacoesExtratosRoute
  '/lancamentos/$id': typeof LancamentosIdRoute
  '/transmissoes/$id': typeof TransmissoesIdRoute
  '/transmissoes/fila': typeof TransmissoesFilaRoute
  '/arquivos/': typeof ArquivosIndexRoute
  '/caixas/': typeof CaixasIndexRoute
  '/comprovantes/': typeof ComprovantesIndexRoute
  '/extratos-bancarios/': typeof ExtratosBancariosIndexRoute
  '/filiais/': typeof FiliaisIndexRoute
  '/gerenciador-anexacao/': typeof GerenciadorAnexacaoIndexRoute
  '/importacoes/': typeof ImportacoesIndexRoute
  '/lancamentos/': typeof LancamentosIndexRoute
  '/sugestoes-combinacoes/': typeof SugestoesCombinacoesIndexRoute
  '/transmissoes/': typeof TransmissoesIndexRoute
  '/usuarios/': typeof UsuariosIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/caixas/$id': typeof CaixasIdRoute
  '/comprovantes/$id': typeof ComprovantesIdRoute
  '/extratos-bancarios/$id': typeof ExtratosBancariosIdRoute
  '/importacoes/$id': typeof ImportacoesIdRoute
  '/importacoes/extratos': typeof ImportacoesExtratosRoute
  '/lancamentos/$id': typeof LancamentosIdRoute
  '/transmissoes/$id': typeof TransmissoesIdRoute
  '/transmissoes/fila': typeof TransmissoesFilaRoute
  '/arquivos': typeof ArquivosIndexRoute
  '/caixas': typeof CaixasIndexRoute
  '/comprovantes': typeof ComprovantesIndexRoute
  '/extratos-bancarios': typeof ExtratosBancariosIndexRoute
  '/filiais': typeof FiliaisIndexRoute
  '/gerenciador-anexacao': typeof GerenciadorAnexacaoIndexRoute
  '/importacoes': typeof ImportacoesIndexRoute
  '/lancamentos': typeof LancamentosIndexRoute
  '/sugestoes-combinacoes': typeof SugestoesCombinacoesIndexRoute
  '/transmissoes': typeof TransmissoesIndexRoute
  '/usuarios': typeof UsuariosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/caixas/$id': typeof CaixasIdRoute
  '/comprovantes/$id': typeof ComprovantesIdRoute
  '/extratos-bancarios/$id': typeof ExtratosBancariosIdRoute
  '/importacoes/$id': typeof ImportacoesIdRoute
  '/importacoes/extratos': typeof ImportacoesExtratosRoute
  '/lancamentos/$id': typeof LancamentosIdRoute
  '/transmissoes/$id': typeof TransmissoesIdRoute
  '/transmissoes/fila': typeof TransmissoesFilaRoute
  '/arquivos/': typeof ArquivosIndexRoute
  '/caixas/': typeof CaixasIndexRoute
  '/comprovantes/': typeof ComprovantesIndexRoute
  '/extratos-bancarios/': typeof ExtratosBancariosIndexRoute
  '/filiais/': typeof FiliaisIndexRoute
  '/gerenciador-anexacao/': typeof GerenciadorAnexacaoIndexRoute
  '/importacoes/': typeof ImportacoesIndexRoute
  '/lancamentos/': typeof LancamentosIndexRoute
  '/sugestoes-combinacoes/': typeof SugestoesCombinacoesIndexRoute
  '/transmissoes/': typeof TransmissoesIndexRoute
  '/usuarios/': typeof UsuariosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/caixas/$id'
    | '/comprovantes/$id'
    | '/extratos-bancarios/$id'
    | '/importacoes/$id'
    | '/importacoes/extratos'
    | '/lancamentos/$id'
    | '/transmissoes/$id'
    | '/transmissoes/fila'
    | '/arquivos/'
    | '/caixas/'
    | '/comprovantes/'
    | '/extratos-bancarios/'
    | '/filiais/'
    | '/gerenciador-anexacao/'
    | '/importacoes/'
    | '/lancamentos/'
    | '/sugestoes-combinacoes/'
    | '/transmissoes/'
    | '/usuarios/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/caixas/$id'
    | '/comprovantes/$id'
    | '/extratos-bancarios/$id'
    | '/importacoes/$id'
    | '/importacoes/extratos'
    | '/lancamentos/$id'
    | '/transmissoes/$id'
    | '/transmissoes/fila'
    | '/arquivos'
    | '/caixas'
    | '/comprovantes'
    | '/extratos-bancarios'
    | '/filiais'
    | '/gerenciador-anexacao'
    | '/importacoes'
    | '/lancamentos'
    | '/sugestoes-combinacoes'
    | '/transmissoes'
    | '/usuarios'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/caixas/$id'
    | '/comprovantes/$id'
    | '/extratos-bancarios/$id'
    | '/importacoes/$id'
    | '/importacoes/extratos'
    | '/lancamentos/$id'
    | '/transmissoes/$id'
    | '/transmissoes/fila'
    | '/arquivos/'
    | '/caixas/'
    | '/comprovantes/'
    | '/extratos-bancarios/'
    | '/filiais/'
    | '/gerenciador-anexacao/'
    | '/importacoes/'
    | '/lancamentos/'
    | '/sugestoes-combinacoes/'
    | '/transmissoes/'
    | '/usuarios/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  CaixasIdRoute: typeof CaixasIdRoute
  ComprovantesIdRoute: typeof ComprovantesIdRoute
  ExtratosBancariosIdRoute: typeof ExtratosBancariosIdRoute
  ImportacoesIdRoute: typeof ImportacoesIdRoute
  ImportacoesExtratosRoute: typeof ImportacoesExtratosRoute
  LancamentosIdRoute: typeof LancamentosIdRoute
  TransmissoesIdRoute: typeof TransmissoesIdRoute
  TransmissoesFilaRoute: typeof TransmissoesFilaRoute
  ArquivosIndexRoute: typeof ArquivosIndexRoute
  CaixasIndexRoute: typeof CaixasIndexRoute
  ComprovantesIndexRoute: typeof ComprovantesIndexRoute
  ExtratosBancariosIndexRoute: typeof ExtratosBancariosIndexRoute
  FiliaisIndexRoute: typeof FiliaisIndexRoute
  GerenciadorAnexacaoIndexRoute: typeof GerenciadorAnexacaoIndexRoute
  ImportacoesIndexRoute: typeof ImportacoesIndexRoute
  LancamentosIndexRoute: typeof LancamentosIndexRoute
  SugestoesCombinacoesIndexRoute: typeof SugestoesCombinacoesIndexRoute
  TransmissoesIndexRoute: typeof TransmissoesIndexRoute
  UsuariosIndexRoute: typeof UsuariosIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/usuarios/': {
      id: '/usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios/'
      preLoaderRoute: typeof UsuariosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transmissoes/': {
      id: '/transmissoes/'
      path: '/transmissoes'
      fullPath: '/transmissoes/'
      preLoaderRoute: typeof TransmissoesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sugestoes-combinacoes/': {
      id: '/sugestoes-combinacoes/'
      path: '/sugestoes-combinacoes'
      fullPath: '/sugestoes-combinacoes/'
      preLoaderRoute: typeof SugestoesCombinacoesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lancamentos/': {
      id: '/lancamentos/'
      path: '/lancamentos'
      fullPath: '/lancamentos/'
      preLoaderRoute: typeof LancamentosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/importacoes/': {
      id: '/importacoes/'
      path: '/importacoes'
      fullPath: '/importacoes/'
      preLoaderRoute: typeof ImportacoesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gerenciador-anexacao/': {
      id: '/gerenciador-anexacao/'
      path: '/gerenciador-anexacao'
      fullPath: '/gerenciador-anexacao/'
      preLoaderRoute: typeof GerenciadorAnexacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/filiais/': {
      id: '/filiais/'
      path: '/filiais'
      fullPath: '/filiais/'
      preLoaderRoute: typeof FiliaisIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extratos-bancarios/': {
      id: '/extratos-bancarios/'
      path: '/extratos-bancarios'
      fullPath: '/extratos-bancarios/'
      preLoaderRoute: typeof ExtratosBancariosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comprovantes/': {
      id: '/comprovantes/'
      path: '/comprovantes'
      fullPath: '/comprovantes/'
      preLoaderRoute: typeof ComprovantesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/caixas/': {
      id: '/caixas/'
      path: '/caixas'
      fullPath: '/caixas/'
      preLoaderRoute: typeof CaixasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arquivos/': {
      id: '/arquivos/'
      path: '/arquivos'
      fullPath: '/arquivos/'
      preLoaderRoute: typeof ArquivosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transmissoes/fila': {
      id: '/transmissoes/fila'
      path: '/transmissoes/fila'
      fullPath: '/transmissoes/fila'
      preLoaderRoute: typeof TransmissoesFilaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transmissoes/$id': {
      id: '/transmissoes/$id'
      path: '/transmissoes/$id'
      fullPath: '/transmissoes/$id'
      preLoaderRoute: typeof TransmissoesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lancamentos/$id': {
      id: '/lancamentos/$id'
      path: '/lancamentos/$id'
      fullPath: '/lancamentos/$id'
      preLoaderRoute: typeof LancamentosIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/importacoes/extratos': {
      id: '/importacoes/extratos'
      path: '/importacoes/extratos'
      fullPath: '/importacoes/extratos'
      preLoaderRoute: typeof ImportacoesExtratosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/importacoes/$id': {
      id: '/importacoes/$id'
      path: '/importacoes/$id'
      fullPath: '/importacoes/$id'
      preLoaderRoute: typeof ImportacoesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/extratos-bancarios/$id': {
      id: '/extratos-bancarios/$id'
      path: '/extratos-bancarios/$id'
      fullPath: '/extratos-bancarios/$id'
      preLoaderRoute: typeof ExtratosBancariosIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/comprovantes/$id': {
      id: '/comprovantes/$id'
      path: '/comprovantes/$id'
      fullPath: '/comprovantes/$id'
      preLoaderRoute: typeof ComprovantesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/caixas/$id': {
      id: '/caixas/$id'
      path: '/caixas/$id'
      fullPath: '/caixas/$id'
      preLoaderRoute: typeof CaixasIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  CaixasIdRoute: CaixasIdRoute,
  ComprovantesIdRoute: ComprovantesIdRoute,
  ExtratosBancariosIdRoute: ExtratosBancariosIdRoute,
  ImportacoesIdRoute: ImportacoesIdRoute,
  ImportacoesExtratosRoute: ImportacoesExtratosRoute,
  LancamentosIdRoute: LancamentosIdRoute,
  TransmissoesIdRoute: TransmissoesIdRoute,
  TransmissoesFilaRoute: TransmissoesFilaRoute,
  ArquivosIndexRoute: ArquivosIndexRoute,
  CaixasIndexRoute: CaixasIndexRoute,
  ComprovantesIndexRoute: ComprovantesIndexRoute,
  ExtratosBancariosIndexRoute: ExtratosBancariosIndexRoute,
  FiliaisIndexRoute: FiliaisIndexRoute,
  GerenciadorAnexacaoIndexRoute: GerenciadorAnexacaoIndexRoute,
  ImportacoesIndexRoute: ImportacoesIndexRoute,
  LancamentosIndexRoute: LancamentosIndexRoute,
  SugestoesCombinacoesIndexRoute: SugestoesCombinacoesIndexRoute,
  TransmissoesIndexRoute: TransmissoesIndexRoute,
  UsuariosIndexRoute: UsuariosIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
